import { createSelector } from '@reduxjs/toolkit';
import { emptyObject } from 'vet-bones/constants';

import { projectSelector } from 'src/selectors/project';
import { ProjectVirtualGraph } from 'src/store/state/projects';

export const projectVirtualGraphsByIdSelector = (projectId: string) =>
  createSelector(
    projectSelector(projectId),
    (project) =>
      project?.virtualGraphsById ||
      (emptyObject as unknown as Record<string, ProjectVirtualGraph>)
  );
